import React, { useState, useEffect } from 'react';
// APNI IMAGE YAHAN IMPORT KARO
import certificateImage from '../img/aaaservices/CERTIFICATE-2.jpg'; // ← Apni image ka sahi path do

const CertificatePopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasClosedPopup = sessionStorage.getItem('certificatePopupClosed');
    
    if (!hasClosedPopup) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('certificatePopupClosed', 'true');
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-container">
        <button className="close-button" onClick={handleClose}>✕</button>
        
        <div className="certificate-wrapper">
          {/* IMPORTED IMAGE YAHAN USE KARO */}
          <img 
            src={certificateImage}  // ← Bas yahan variable name daal do
            alt="Certificate"
            className="certificate-image"
          />
        </div>
      </div>
      
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.85);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          animation: fadeIn 0.3s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .popup-container {
          position: relative;
          max-width: 90%;
          max-height: 90%;
          animation: scaleUp 0.3s ease-out;
        }

        @keyframes scaleUp {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        .close-button {
          position: absolute;
          top: -15px;
          right: -15px;
          width: 35px;
          height: 35px;
          background: #ff4757;
          border: none;
          border-radius: 50%;
          font-size: 20px;
          cursor: pointer;
          color: white;
          z-index: 10;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-button:hover {
          background: #ff0000;
          transform: scale(1.1);
        }

        .certificate-wrapper {
          background: white;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
        }

        .certificate-image {
          width: 100%;
          height: auto;
          display: block;
          max-width: 800px;
          max-height: 80vh;
          object-fit: contain;
        }

        @media (max-width: 768px) {
          .close-button {
            top: -10px;
            right: -10px;
            width: 30px;
            height: 30px;
            font-size: 16px;
          }
          
          .certificate-image {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};



export default CertificatePopup;